import _regeneratorRuntime from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  "class": "group-box"
};
var _hoisted_2 = {
  "class": "group-box-header"
};
var _hoisted_3 = {
  "class": "group-box-header-title"
};
var _hoisted_4 = {
  key: 0,
  "class": "group-list"
};
var _hoisted_5 = {
  "class": "group-list-item"
};
var _hoisted_6 = {
  "class": "group-list-item-label"
};
var _hoisted_7 = {
  "class": "group-list-item-label"
};
var _hoisted_8 = ["onUpdate:modelValue", "placeholder"];
var _hoisted_9 = ["onClick"];
var _hoisted_10 = {
  "class": "content"
};
var _hoisted_11 = {
  "class": "group-list-introduction"
};
var _hoisted_12 = {
  "class": "group-list-item"
};
var _hoisted_13 = {
  "class": "group-list-item-label"
};
var _hoisted_14 = {
  "class": "content"
};
var _hoisted_15 = {
  key: 0,
  "class": "group-h5-list-item-introduction"
};
var _hoisted_16 = {
  "class": "introduction-name"
};
var _hoisted_17 = {
  "class": "introduction-detail"
};
var _hoisted_18 = ["href"];
var _hoisted_19 = {
  key: 1,
  "class": "group-list group-list-edit"
};
var _hoisted_20 = ["placeholder"];
var _hoisted_21 = {
  "class": "group-profile-footer"
};
var _hoisted_22 = ["disabled"];
import TUIChatEngine, { TUITranslateService, TUIGroupService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { computed, reactive, watchEffect } from "../../../adapter-vue";
import documentLink from "../../../utils/documentLink";
import { isPC } from "../../../utils/env";
import Icon from "../../common/Icon.vue";
import backIcon from "../../../assets/icon/back.svg";
import closeIcon from "../../../assets/icon/icon-close.svg";
import rightIcon from "../../../assets/icon/right-icon.svg";
import GroupIntroduction from "./group-introduction/index.vue";
import { groupIntroConfig, findGroupIntroConfig } from "./group-introduction/config";
import Dialog from "../../common/Dialog/index.vue";
import { Toast, TOAST_TYPE } from "../../common/Toast/index";
import Avatar from "../../common/Avatar/index.vue";
import Server from "../server";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var TUIGroupServer = Server.getInstance();
    var TUIConstants = TUIGroupServer.constants;
    var groupInfo = reactive({
      profile: {
        groupID: '',
        name: '',
        type: groupIntroConfig[0].type,
        avatar: groupIntroConfig[0].icon,
        introduction: '',
        notification: '',
        // joinOption: '',
        memberList: [],
        isSupportTopic: false
      },
      groupConfig: {
        title: '',
        value: '',
        key: '',
        type: '',
        placeholder: ''
      },
      isEdit: false
    });
    watchEffect(function () {
      var params = TUIGroupServer.getOnCallParams(TUIConstants.TUIGroup.SERVICE.METHOD.CREATE_GROUP);
      groupInfo.profile.memberList = params.memberList;
      groupInfo.groupConfig.title = params.title;
    });
    var groupTypeDetail = computed(function () {
      return findGroupIntroConfig(groupInfo.profile.type);
    });
    var headerTitle = computed(function () {
      var name = '添加群聊';
      if (groupInfo.isEdit) {
        name = groupInfo.groupConfig.title;
      }
      return TUITranslateService.t("TUIGroup.".concat(name));
    });
    var createInfo = computed(function () {
      var groupNameInput = {
        name: TUITranslateService.t("TUIGroup.群名称"),
        key: "name",
        placeholder: TUITranslateService.t("TUIGroup.请输入群名称")
      };
      var groupIDInput = {
        name: "".concat(TUITranslateService.t("TUIGroup.群ID"), "(").concat(TUITranslateService.t("TUIGroup.选填"), ")"),
        key: "groupID",
        placeholder: TUITranslateService.t("TUIGroup.请输入群ID")
      };
      return groupInfo.profile.type === TUIChatEngine.TYPES.GRP_COMMUNITY ? [groupNameInput] : [groupNameInput, groupIDInput];
    });
    var submitDisabledStatus = computed(function () {
      return groupInfo.profile.name === '' && !groupInfo.isEdit;
    });
    var selected = function selected(type) {
      if (groupInfo.profile.type !== type) {
        groupInfo.profile.type = type;
        groupInfo.profile.avatar = findGroupIntroConfig(type).icon;
        if (groupInfo.isEdit) {
          groupInfo.groupConfig.value = type;
        }
      }
    };
    var createGroup = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
        var res, type;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              options.memberList = options.memberList.map(function (item) {
                return {
                  userID: item.userID
                };
              });
              if (options.type === TUIChatEngine.TYPES.GRP_COMMUNITY) {
                delete options.groupID;
              }
              _context.next = 5;
              return TUIGroupService.createGroup(options);
            case 5:
              res = _context.sent;
              type = res.data.group.type;
              if (!(type === TUIChatEngine.TYPES.GRP_AVCHATROOM)) {
                _context.next = 10;
                break;
              }
              _context.next = 10;
              return TUIGroupService.joinGroup({
                groupID: res.data.group.groupID,
                applyMessage: ''
              });
            case 10:
              handleCompleteCreate(res.data.group);
              Toast({
                message: TUITranslateService.t("TUIGroup.群组创建成功"),
                type: TOAST_TYPE.SUCCESS
              });
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              Toast({
                message: _context.t0.message,
                type: TOAST_TYPE.ERROR
              });
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 14]]);
      }));
      return function createGroup(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var submit = function submit() {
      var profile = groupInfo.profile;
      if (groupInfo.isEdit) {
        groupInfo.profile[groupInfo.groupConfig.key] = groupInfo.groupConfig.value;
        return groupInfo.isEdit = !groupInfo.isEdit;
      } else {
        createGroup(profile);
      }
    };
    var closeCreated = function closeCreated() {
      if (groupInfo.isEdit) {
        return groupInfo.isEdit = !groupInfo.isEdit;
      }
      handleCompleteCreate(null);
    };
    var edit = function edit(label) {
      groupInfo.isEdit = !groupInfo.isEdit;
      groupInfo.groupConfig.key = label;
      groupInfo.groupConfig.value = groupInfo.profile[label];
      switch (label) {
        case 'name':
          groupInfo.groupConfig.title = '设置群名称';
          groupInfo.groupConfig.placeholder = '请输入群名称';
          groupInfo.groupConfig.type = 'input';
          break;
        case 'groupID':
          groupInfo.groupConfig.title = '设置群ID';
          groupInfo.groupConfig.placeholder = '请输入群ID';
          groupInfo.groupConfig.type = 'input';
          break;
        case 'type':
          groupInfo.groupConfig.title = '选择群类型';
          groupInfo.groupConfig.type = 'select';
          break;
      }
    };
    var handleCompleteCreate = function handleCompleteCreate(group) {
      TUIStore.update(StoreName.GRP, "isShowCreateComponent", false);
      var callback = TUIGroupServer.getOnCallCallback(TUIConstants.TUIGroup.SERVICE.METHOD.CREATE_GROUP);
      callback && callback(group);
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Dialog, {
        show: true,
        isH5: !_unref(isPC),
        isHeaderShow: false,
        isFooterShow: false,
        background: false,
        "onUpdate:show": closeCreated
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", {
            "class": _normalizeClass(["group", [!_unref(isPC) ? 'group-h5' : '']])
          }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createVNode(Icon, {
            file: _unref(isPC) ? _unref(closeIcon) : _unref(backIcon),
            "class": "icon-close",
            onOnClick: closeCreated,
            size: "16px"
          }, null, 8, ["file"]), _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(headerTitle)), 1)]), !_unref(groupInfo).isEdit ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [_createElementVNode("li", _hoisted_5, [_createElementVNode("label", _hoisted_6, _toDisplayString(_unref(TUITranslateService).t('TUIGroup.群头像')), 1), _createVNode(Avatar, {
            url: _unref(groupInfo).profile.avatar
          }, null, 8, ["url"])]), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(createInfo), function (item, index) {
            return _openBlock(), _createElementBlock("li", {
              "class": "group-list-item",
              key: index
            }, [_createElementVNode("label", _hoisted_7, _toDisplayString(item.name), 1), _unref(isPC) ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              type: "text",
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return _unref(groupInfo).profile[item.key] = $event;
              },
              placeholder: item.placeholder
            }, null, 8, _hoisted_8)), [[_vModelText, _unref(groupInfo).profile[item.key]]]) : (_openBlock(), _createElementBlock("span", {
              key: 1,
              "class": "group-h5-list-item-content",
              onClick: function onClick($event) {
                return edit(item.key);
              }
            }, [_createElementVNode("p", _hoisted_10, _toDisplayString(_unref(groupInfo).profile[item.key]), 1), _createVNode(Icon, {
              file: _unref(rightIcon)
            }, null, 8, ["file"])], 8, _hoisted_9))]);
          }), 128)), _createElementVNode("li", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("label", _hoisted_13, _toDisplayString(_unref(TUITranslateService).t('TUIGroup.群类型')), 1), _unref(isPC) ? (_openBlock(), _createBlock(GroupIntroduction, {
            key: 0,
            groupType: _unref(groupInfo).profile.type,
            onSelectType: selected
          }, null, 8, ["groupType"])) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            "class": "group-h5-list-item-content",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return edit('type');
            })
          }, [_createElementVNode("p", _hoisted_14, _toDisplayString(_unref(groupTypeDetail).label), 1), _createVNode(Icon, {
            file: _unref(rightIcon)
          }, null, 8, ["file"])]))]), !_unref(isPC) ? (_openBlock(), _createElementBlock("article", _hoisted_15, [_createElementVNode("label", _hoisted_16, _toDisplayString(_unref(groupTypeDetail).label) + "：", 1), _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(groupTypeDetail).detail), 1), _createElementVNode("a", {
            href: _unref(documentLink).product.url,
            target: "view_window"
          }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.".concat(_unref(groupTypeDetail).src))), 9, _hoisted_18)])) : _createCommentVNode("", true)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_19, [_unref(groupInfo).groupConfig.type === 'input' ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            "class": "group-name-input",
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return _unref(groupInfo).groupConfig.value = $event;
            }),
            placeholder: _unref(TUITranslateService).t("TUIGroup.".concat(_unref(groupInfo).groupConfig.placeholder))
          }, null, 8, _hoisted_20)), [[_vModelText, _unref(groupInfo).groupConfig.value]]) : (_openBlock(), _createBlock(GroupIntroduction, {
            key: 1,
            "class": "group-introduction-list",
            groupType: _unref(groupInfo).groupConfig.value,
            onSelectType: selected
          }, null, 8, ["groupType"]))])), _createElementVNode("footer", _hoisted_21, [_unref(isPC) && !_unref(groupInfo).isEdit ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            "class": "btn-default",
            onClick: closeCreated
          }, _toDisplayString(_unref(TUITranslateService).t('TUIGroup.取消')), 1)) : _createCommentVNode("", true), _createElementVNode("button", {
            "class": "btn-submit",
            disabled: _unref(submitDisabledStatus),
            onClick: submit
          }, _toDisplayString(_unref(TUITranslateService).t('TUIGroup.确认')), 9, _hoisted_22)])])], 2)];
        }),
        _: 1
      }, 8, ["isH5"]);
    };
  }
});